import { render } from "./EmployeeBadge.vue?vue&type=template&id=4b3daa22&scoped=true"
import script from "./EmployeeBadge.vue?vue&type=script&lang=js"
export * from "./EmployeeBadge.vue?vue&type=script&lang=js"

import "./EmployeeBadge.vue?vue&type=style&index=0&id=4b3daa22&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3daa22"]])

export default __exports__